import Vue from 'vue';

Vue.component('subsidy-index-es', () =>
    import(/* webpackChunkName: 'subsidy-index-es' */ './subsidy-index-es.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/subsidy/index.js